export const templatesKeys = {
  all: ["templates"] as const,
  lists: () => [...templatesKeys.all, "list"] as const,
  details: () => [...templatesKeys.all, "detail"] as const,
  detail: (id: number | null | undefined) => [...templatesKeys.details(), id] as const,
  items: (id: number | null | undefined) => [...templatesKeys.detail(id), "items"] as const,
};
